































import { Duration } from '@/types/global';
import { Vue, Component, Watch } from 'vue-property-decorator';
import { State, Action, Mutation } from 'vuex-class';
import timeFormat from '@/utils/timeFormat';

@Component
export default class Footerssd extends Vue {
  @State('rocketbot') private rocketbotGlobal: any;
  @Action('SET_DURATION') private SET_DURATION: any;
  @Action('SET_UTC') private SET_UTC: any;
  private lang: any = '';
  private utc: any = window.localStorage.getItem('utc') || -(new Date().getTimezoneOffset() / 60);
  @Watch('utc')
  private onUtcUpdate() {
    if (this.utc < -12) { this.utc = -12; }
    if (this.utc > 14) { this.utc = 14; }
    if (this.utc === '') { this.utc = 0; }
    this.SET_UTC(this.utc);
    window.localStorage.setItem('utc', this.utc.toString());
  }
  private setLang() {
    if (this.lang === 'zh') {
      this.$i18n.locale = 'en';
      window.localStorage.setItem('lang', 'en');
      this.lang = 'en';
    } else {
      this.$i18n.locale = 'zh';
      window.localStorage.setItem('lang', 'zh');
      this.lang = 'zh';
    }
  }
  private beforeMount() {
    this.lang = window.localStorage.getItem('lang');
  }
}
